import '../styles/Home.css';
import '../styles/Footer.css';
import { useTranslation } from 'react-i18next';

function Footer() {
	const { t } = useTranslation();
	return (
		<div className="footer">
            <div className='footer-brand'>
                <span className='span-gold'><a href="https://lps-consulting.fr" target="_blank" rel="noreferrer">LPS CONSULTING</a></span>
                <span className='span-white'>&nbsp;- {new Date().getFullYear()} - Made with ❤️ in 🇫🇷</span>
            </div>
			<div className='footer-links'>
				<a href='/about'>{t('footer.about')}</a>
				<a href='/contact'>{t('footer.contact')}</a>
				<a href='/terms'>{t('footer.terms')}</a>
				<a href='/privacy'>{t('footer.privacy')}</a>
			</div>
		</div>
	)
}

export default Footer
